import { errorLogger, ErrorLevel } from './errorLogger';

type SeverityLevel = 'fatal' | 'error' | 'warning' | 'log' | 'info' | 'debug';

export async function initSentry(): Promise<void> {
  console.log('Monitoring initialized (console logging only)');
}

export function setUserContext(user: { id: string; email?: string; role?: string }): void {
  console.log('User context set:', { id: user.id, role: user.role });
}

export function clearUserContext(): void {
  console.log('User context cleared');
}

export function captureException(error: Error, context?: Record<string, any>): void {
  console.error('Error captured:', error.message, error);
  if (context) {
    console.error('Error context:', context);
  }

  errorLogger.logError(error.message, error.stack, context);
}

export function captureMessage(message: string, level: SeverityLevel = 'info'): void {
  const logFn = level === 'error' || level === 'fatal' ? console.error :
                level === 'warning' ? console.warn : console.log;
  logFn(`[${level}] ${message}`);

  if (level === 'fatal') {
    errorLogger.logCritical(message);
  } else if (level === 'error') {
    errorLogger.logError(message);
  } else if (level === 'warning') {
    errorLogger.logWarning(message);
  }
}

export function addBreadcrumb(breadcrumb: {
  message: string;
  category?: string;
  level?: SeverityLevel;
  data?: Record<string, any>
}): void {
  console.log('Breadcrumb:', breadcrumb.message, breadcrumb.data || '');
}

export function setTag(key: string, value: string): void {
  console.log(`Tag set: ${key}=${value}`);
}

export function setContext(name: string, context: Record<string, any>): void {
  console.log(`Context set: ${name}`, context);
}

export function startTransaction(name: string, operation: string): any {
  console.log(`Transaction started: ${name} (${operation})`);
  return undefined;
}

export const Sentry = null;
